import ENV from 'env';
import './leaflet-map.scss';

class LeafletMapcontoller {
  constructor($compile, $element, $interpolate, $scope, $q, L) {
    'ngInject';

    this.$compile = $compile;
    this.$element = $element;
    this.$interpolate = $interpolate;
    this.$scope = $scope;
    this.$q = $q;
    this.L = L;
  }

  $onChanges(changesObject) {
    this.centerCopy = this.center || { lat: 47, lng: 8.6 };
    console.log(this.centerCopy);
    this.pointsCopy = [] + this.markerPoints;
    this.buildMap().then(this.buildMarkers.bind(this));
  }

  buildMap() {
    if (this.map) {
      return this.$q.when(this.map);
    }

    this.mapId = `map-${(new Date).getTime()}`;
    this.$element.attr('id', this.mapId);

    this.map = new this.L.Map(this.mapId, {
      center: new this.L.LatLng(this.centerCopy.lat, this.centerCopy.lng),
      zoom: this.zoom || 3,
    });

    const tileServer = 'https://api.mapbox.com/styles/v1/{account}/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}',
    pingstaLayer = new this.L.TileLayer(tileServer, {
      attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>',
      minZoom: 0,
      maxZoom: 17,
      account: ENV.mapbox.account,
      id: ENV.mapbox.id,
      accessToken: ENV.mapbox.accessToken
    });
    this.map.addLayer(pingstaLayer);

    return this.$q.when(this.map);
  }

  buildMarkers(map) {
    const markers = L.markerClusterGroup();
    if (this.markerPoints) {
      this.markerPoints.forEach((member) => {
        const marker = L.marker([member.lat, member.lng])

        if (!this.withoutPopups) {
          const popupTemplateScope = this.$scope.$new();
          popupTemplateScope.$ctrl = {member};
          const popupPrecompiledTemplate = this.$compile('<member-card class="member-card" member="member"></member-card>');
          const popupTemplate = popupPrecompiledTemplate(popupTemplateScope);
          const interpolatedPopupTemplate = this.$interpolate(popupTemplate.html())(popupTemplateScope); // TODO hack, $compile should do interpolation, investigate
          const popup = this.L.popup({
            maxWidth: 340,
            offset: L.point(200, 185),
          });
          popup.setContent(interpolatedPopupTemplate);
          marker.bindPopup(popup);
        }

        markers.addLayer(marker);
      });
    }
    this.map.addLayer(markers);
  }
}

export default function() {
  return {
    restrict: 'EA',
    controller: LeafletMapcontoller,
    scope: {},
    controllerAs: '$ctrl',
    bindToController: {
      zoom: '<',
      center: '<',
      markerPoints: '<',
      withoutPopups: '<',
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/screens/engineer/components/pleaflet/leaflet-map.directive.js